export default () => ({
    homes: [],
    home: {
        title: '',
        image: '',
        description: '',
        permalink: '#',
        sections: [

        ]
    },

    isMobile: false,

    init() {
        this.fetchServerData();
        this.setIsMobile();
    },

    selectHome(homeItem) {
        this.home = homeItem;
    },

    async fetchServerData() {
        try {
            const response = await fetch(`/wp-json/custom/v1/homes?${new Date().getTime()}`);

            const data = await response.json();

            this.homes = data.homes.map((home, index) => ({
                id: index + 1,
                title: home.title,
                image:  home.image,
                description: home.description,
                link: home.permalink,
                location: home.location,
                sections: home.sections
            }));

            this.home = this.homes[0];
        } catch (error) {
            console.error("Error fetching home data:", error);
        }
    },

    setIsMobile() {
        this.isMobile = window.innerWidth <= 1023;
    }
});
